import DesCatalogPartConfigViewModel from '../../../../catalog/src/viewmodel/DesCatalogPartConfigViewModel.json';
import { DesBaseCatalogAcc } from '../utils/des-base-catalog-acc';
import { DesAccConstants } from '../constant/desAccConstants';

export default class DesCatalogPartConfig extends DesBaseCatalogAcc {
    constructor() {
        super(DesCatalogPartConfigViewModel);
    }

    get partId() {
        return this.getAttribute(DesAccConstants.PART_ID);
    }

    get attachments() {
        return this.getAttribute(DesAccConstants.ATTACHMENTS);
    }

    get featureGroupId() {
        return this.getAttribute(DesAccConstants.FEATURE_GROUP_ID);
    }

    get disableCarousel() {
        const disableCarousel = this.getAttribute(DesAccConstants.DISABLE_CAROUSEL);
        console.log(`Inside disableCarousel of des-catalog-part-config and returning ${disableCarousel}`);
        return this.getAttribute(DesAccConstants.DISABLE_CAROUSEL);
    }

    getProps() {
        return {
            accsessionid: this.accsessionid,
            attachments: this.attachments,
            catalogspaceid: this.catalogspaceId,
            hideelements: this.hideElements,
            partid: this.partId,
            provider: this.provider,
            featureGroupId: this.featureGroupId,
            disablecarousel: this.disableCarousel
        };
    }

    static get observedAttributes() {
        return [
            ...DesBaseCatalogAcc.observedAttributes,
            DesAccConstants.ATTACHMENTS,
            DesAccConstants.PART_ID,
            DesAccConstants.HIDE_ELEMENTS,
            DesAccConstants.FEATURE_GROUP_ID,
            DesAccConstants.DISABLE_CAROUSEL
        ];
    }
}

if (!window.customElements.get('des-catalog-part-config')) {
    window.customElements.define('des-catalog-part-config', DesCatalogPartConfig);
}
